import React from 'react';
import './AppointmentSettings.css';

const AppointmentSettings = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="appointment-settings-shell">{children}</div>;
};

export default AppointmentSettings;
